import { makeEditableDateCell } from "./WorkEditableDateCell";

/** The Work start column's cell. */
export const WorkStartDateCell = makeEditableDateCell("workStartDate");
WorkStartDateCell.displayName = "WorkStartDateCell";
